import React, { Component } from 'react';

export default  function(RootComp) {

  var resizingTree = false;
  var resizingImages = false;
  var resizingGrid = false;

  class RootViewResizeHoc extends Component {
    componentDidMount() {
      window.addEventListener('resize', this._handleResize.bind(this));
    }

    _handleResize() {
      this.props.resizeTree(window.innerWidth / 4);
    }

    _mouseDownTreeDivider(e) {
      resizingTree = true;
    }

    _mouseMove(e) {
      if (resizingTree || resizingImages || resizingGrid) {

        if (resizingTree) {
          this.props.resizeTree(e.clientX);
        }

        e.stopPropagation();
        e.preventDefault();
        e.cancelBubble = true;
        e.returnValue = false;

        return false;
      }
    }

   _mouseUp(e) {
      resizingTree = false;
   }

    _calculateTreeDividerX(windowWidth) {
      if(this.props.isTablet){
        return windowWidth / 2.2;
      }
      else if (this.props.treeDividerX < 0) {
        return windowWidth / 3;
      } else if (this.props.treeDividerX < windowWidth /5) {
        return windowWidth / 7;
      } else if (this.props.treeDividerX > windowWidth * 0.7) {
        return windowWidth * 0.7;
      } else {
        return this.props.treeDividerX;
      }
    }


    render() {
      if (this.props.isMobilePhone) {
        return <RootComp {...this.props}/>;
      }



      var windowWidth = window.innerWidth;
      var treeDividerX = ~~this._calculateTreeDividerX(windowWidth);

      const contentLeftStyle = {width: treeDividerX - 9 + 'px'};

      const contentRightStyle = {width: (windowWidth - treeDividerX) - 8 + 'px'};
      const treeResizeDividerStyle = {left: treeDividerX - 9 + 'px'};

      return <RootComp {...this.props}
        mouseMove={this._mouseMove.bind(this)}
        mouseUp={this._mouseUp.bind(this)}
        mouseDownTreeDivider={this._mouseDownTreeDivider.bind(this)}
        contentLeftStyle={contentLeftStyle}
        contentRightStyle={contentRightStyle}
        treeResizeDividerStyle={treeResizeDividerStyle}
     />;
    }
  }


  return RootViewResizeHoc;
}



/** WEBPACK FOOTER **
 ** app/components/root/view/root-resize-hoc.js
 **/